import { PrimaryButton, Shimmer, TooltipHost } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { shimmerWithElementGapRow } from "../../helper/ShimmerElement";
import ContactsPanel from "./ContactPanel";

// Convert name to proper case (e.g., "MHAMPTON" -> "Mhampton")
const toProperCase = (name: string | undefined): string => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

export default function CustomerContact(props: any) {
  const [isContactOpen, { setTrue: openContactPanel, setFalse: dismissContactPanel }] = useBoolean(false);

  return (
    <div
      style={{
        marginLeft: 15
      }}
    >
      <div style={{ paddingLeft: 7, marginTop: 0 }}>
        <label style={{ paddingBottom: 10 }}>
          <strong>Contact Information :</strong>
        </label>
        <br />
        <br />
        <div style={{ display: "flex" }}>
          {props.loading && (
            <Shimmer
              style={{ width: 120, paddingLeft: 5 }}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            ></Shimmer>
          )}
          {!props.loading && <label> Account Manager</label>}

          {props.loading && (
            <Shimmer
              style={{
                width: 120,
                paddingLeft: 4,
                paddingRight: 3
              }}
              shimmerElements={shimmerWithElementGapRow}
              shimmerColors={{
                shimmer: "rgb(222, 236, 249)"
              }}
            >
              &nbsp;&nbsp;
            </Shimmer>
          )}
          {!props.loading && <div>:&nbsp;{props.accountmgr}</div>}
        </div>
        <br />
        <div>
          <PrimaryButton
            text="Show Contacts"
            onClick={() => openContactPanel()}
            iconProps={{ iconName: "ContactInfo" }}
          />

          <ContactsPanel isOpen={isContactOpen} onDismiss={dismissContactPanel} tenantName={props?.tenantName} tpid={props?.tpid} tenantId={props?.tenantId} accountManager={props?.accountmgr} accountManagerAlias={props?.accountManagerAlias} />
        </div>
      </div>
    </div>
  );
}
